import { SortDescriptor } from '@ds';
import { CaseAccessTicketItem } from '@/api/apis/case';
import {
  accessColumns,
  CaseAccessRoleType,
  getAccessStatusLabel,
  getCaseAccessRoleTypes,
  getUserDisplayName,
} from './config';

const compareString = (a: string, b: string) => a.localeCompare(b);

const compareNullableNumber = (a: number | null, b: number | null) => {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;

  return a - b;
};

const getNameSortValue = (item: CaseAccessTicketItem) => getUserDisplayName(item.forUser).trim().toLowerCase();

const getStatusSortValue = (item: CaseAccessTicketItem) => getAccessStatusLabel(item.status).trim().toLowerCase();

const getUserRoleSortValue = (item: CaseAccessTicketItem) => {
  const roleTypes = getCaseAccessRoleTypes(item);

  const hasOmsRole = roleTypes.includes(CaseAccessRoleType.OMS);
  const hasCommercialAdoptionRole = roleTypes.includes(CaseAccessRoleType.CommercialAdoption);

  if (hasCommercialAdoptionRole && !hasOmsRole) return 0;
  if (hasCommercialAdoptionRole && hasOmsRole) return 1;

  return 2;
};

const getExpirationSortValue = (item: CaseAccessTicketItem): number | null => {
  if (item.status !== 'Active') return null;
  if (item.isInfinite) return Number.POSITIVE_INFINITY;
  if (!item.expiresAt) return null;

  const ms = Date.parse(String(item.expiresAt));

  return Number.isFinite(ms) ? ms : null;
};

export const sortCaseAccessTickets = (data: CaseAccessTicketItem[], sortBy?: SortDescriptor) => {
  if (!sortBy?.column) return data;

  const dir = sortBy.direction === 'descending' ? -1 : 1;
  const column = String(sortBy.column);

  return [...data].sort((a, b) => {
    let res = 0;

    switch (column) {
      case accessColumns.name.key:
        res = compareString(getNameSortValue(a), getNameSortValue(b));
        break;

      case accessColumns.userRole.key:
        res = getUserRoleSortValue(a) - getUserRoleSortValue(b);
        break;

      case accessColumns.accessStatus.key:
        res = compareString(getStatusSortValue(a), getStatusSortValue(b));
        break;

      case accessColumns.accessExpirationDate.key:
        res = compareNullableNumber(getExpirationSortValue(a), getExpirationSortValue(b));
        break;

      default:
        res = 0;
    }

    return res * dir;
  });
};
